import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { documentsActions } from '../../store/actions'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  Box,
  Typography, useTheme
} from '@mui/material'

import { IdScanMicroBlink, CustomLoadingOverlay, CustomMainContainer, Buttons, GeoLocationGeneric } from '../../components'
// import { useStyles } from './MicroblinkStyles'
// import { mainStyles, theme } from '../../styles'
import { MicroblinkFunctions } from './MicroblinkFunctions'
import { Uint8ArraytoB64 } from '../../utils'
import { coreFunctions } from '../../utils'//funciones del nucleo
import { useTranslation } from 'react-i18next'

export default function MicroblinkCamera(props) {
  const localStyles = {}//useStyles()
  const theme = useTheme()
    const location = useLocation()
  const [loadView, setLoadView] = useState(false)
  const [photoTaken, setPhotoTaken] = useState(false);
  const [document, setDocument] = useState('')

  const [activeGeolocation, setActiveGeolocation] = useState(true)
  const [latitude, setLatitude] = useState("-85.05112878")
  const [longitude, setLongitude] = useState("-180")
  const [metadataExtraccion, setMetadataExtraccion] = useState([])
  const [activeCargaINE, setActiveCargaINE] = useState(false)
  const [loadingSDK, setLoadingSDK] = useState(false);
  const [SDKSuccess, setSDKSuccess] = useState(false);

  const uploadSecDoc = useSelector(state => state.UploadSections)
  const uploadDoc = useSelector(state => state.UploadDocuments)

  const folioId = location.state.folioId
  const sectionId = location.state.sectionId
  const docName = location.state.docName
  const sectionName = location.state.sectionName
  const actorId = location.state.actorId
  const sections = location.state.sections
  const activeFacialVerification = location.state.activeFacialVerification

  const ocrInfo = location.state.ocrInfo
  const qrProcess = location.state.qrProcess
  const activeNSections = location.state.activeNSections
  const sectionsCapture = location.state.sectionsCapture

  const ext = '.jpg'

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { t } = useTranslation();

  useEffect(() => {
    if (uploadDoc.items != undefined && uploadDoc.items?.TransactionId != null && loadView) {
      // console.log("uploadDoc.items:-----------------: ", uploadDoc.items)
      if (activeCargaINE == false) {
        const dataToSend = {
          B64Content: document,
          FileId: folioId,
          Actor_Id: actorId,
          SkipActor: null,
          SectionId: sectionId,
          Extension: '.jpg',
          Skip: false,
          SkipReason: null,
          Metadata: metadataExtraccion.length > 0 ? metadataExtraccion : null, //Metadata is always null for this lego, the meta would be send in  RegisterIdentityData2
          ContinueWorkFlow: false, //to upload all files before moving
          Geolocation: {
            Latitude: latitude,
            Longitude: longitude
          }, //Pending
          DeferLoad: false // heavy file, true to load on backgroud 
        }

        console.log("Cargar seccion reuqest----------------: ", dataToSend)
        dispatch(documentsActions.CargaSeccion(dataToSend))
      } else {
        // console.log("Cargar seccion reuqest------uploadDoc.items------ENTRO ELSE++++++++++++++++++++****----: ", uploadDoc.items)
      }
    } if (uploadDoc.error != undefined && loadView) {
      setLoadView(false)
      alert(uploadDoc.error)
    }
  }, [uploadDoc])

  useEffect(() => {
    if (uploadSecDoc.items != undefined && loadView) {
      if (uploadSecDoc.items.Result?.Id != null || uploadSecDoc.items.Result?.Id != undefined) {
        setLoadView(false)
        let documetId = uploadSecDoc.items.Result?.Id
        let docName = uploadSecDoc.items.Result?.Name
        localStorage.removeItem("mb-user-id")
        sessionStorage.removeItem("mb-user-id")
        // console.log("uploadSecDoc.items:-----------------: docName: ", docName, documetId, " - activeFacialVerification: ", activeFacialVerification, uploadSecDoc.items)
        if (docName == "INE / IFE" || docName == "Pasaporte") {
          if (activeFacialVerification) {
            const nextComponent = 'HelpSelfie'
            MicroblinkFunctions.doNextStage({ navigate, nextComponent, folioId, docName, sections, actorId, metadataExtraccion, activeFacialVerification })
          } else {
            const nextComponent = 'ExtractionForm'
            MicroblinkFunctions.doNextStage({ navigate, nextComponent, folioId, sections, docName, documetId, metadataExtraccion, activeFacialVerification })
          }
        }
        else {
          const nextComponent = 'FormWebCamera'
          let doc = document
          let metadatos = metadataExtraccion
          console.log("**********Send INfor Form********: ", doc, "  --- Metdata: ", metadatos)
          MicroblinkFunctions.doNextStage({ navigate, folioId, sectionId, nextComponent, docName, qrProcess, metadatos, doc })
        }
      }
    }
    if (uploadSecDoc.error != undefined && loadView) {
      alert(uploadSecDoc.error)
      setLoadView(false)
    }
  }, [uploadSecDoc])

  const haddleDataCapture = (docData) => {
    console.log("***************Data filtrada-extraccion********************--", docData);
    if (docData != undefined && docData != null) {
      console.log("setMetadataExtraccion(docData.metadata)***********************: ", docData.metadata)
      setMetadataExtraccion(docData.metadata)
      if (docName == "INE / IFE") {
        // console.log("Captura de INE camino----------- ", docData)
        // console.log("sections:------ ", sections)
        setActiveCargaINE(true)

        let dataSections = sections.filter(item => item.Name == "Anverso" || item.Name == "Reverso")
        // console.log("dataSections:------ ", dataSections)
        dataSections.forEach((section, index) => {
          // console.log("itemForeach------------: ", section, docData.imageBase64)
          let convertIMage = getB64ByDocument(section.Name, docData.imageBase64)
          // console.log("Image convert: ", section.Name, " - convertIMage: ", convertIMage)

          const dataforMetadata = {
            File_id: folioId,
            Carga: {
              Referencia: folioId.toString(),
              TransactionId: (localStorage.getItem('TransactionId') == "null" ? null : localStorage.getItem('TransactionId')),
              EsBolqueFin: index == 1 ? true : false,
              TipoDocumento: docName,
              Seccion: section.Name,
              Imagenes: [
                {
                  B64: convertIMage,
                  Extension: ext
                }
              ],
              Metadatos: null
            }
          }

          console.log("dataforMetadata REQUEST--------: section.Name: ", section.Name, " - Request: ", dataforMetadata)
          setLoadView(true)
          setDocument(convertIMage)
          setPhotoTaken(true);
          setLoadView(true)
          // console.log("Change camara-----Anverso----Reverso---:  ", sectionId, dataforMetadata)
          dispatch(documentsActions.CargaDocumento(dataforMetadata))

          const dataToSend = {
            B64Content: convertIMage,
            FileId: folioId,
            Actor_Id: actorId,
            SkipActor: null,
            SectionId: section.Id,
            Extension: '.jpg',
            Skip: false,
            SkipReason: null,
            Metadata: null, //Metadata is always null for this lego, the meta would be send in  RegisterIdentityData2
            ContinueWorkFlow: false, //to upload all files before moving
            Geolocation: {
              Latitude: latitude,
              Longitude: longitude
            }, //Pending
            DeferLoad: false // heavy file, true to load on backgroud 
          }

          console.log("Cargar seccion----------dataToSend------:  section.Id: ", section.Id, " - Request: ", dataToSend)
          dispatch(documentsActions.CargaSeccion(dataToSend))

        })
      } else {
        let convertIMage = docData.imageBase64 === undefined || docData.imageBase64 === null ? null : getB64ByDocument(docName, docData)
        setDocument(convertIMage)

        const dataforMetadata = {
          File_id: folioId,
          Carga: {
            Referencia: folioId.toString(),
            TransactionId: (localStorage.getItem('TransactionId') == "null" ? null : localStorage.getItem('TransactionId')),
            EsBolqueFin: true,
            TipoDocumento: docName,
            Seccion: sectionName,
            Imagenes: [
              {
                B64: convertIMage,
                Extension: ext
              }
            ],
            Metadatos: null
          }
        }
        setPhotoTaken(true);
        setLoadView(true)
        // console.log("Change camara-----Anverso----Reverso---:  ", sectionId, dataforMetadata)
        dispatch(documentsActions.CargaDocumento(dataforMetadata))
      }
    }
  };

  const cancelPhoto = () => {
    localStorage.removeItem("mb-user-id")
    sessionStorage.removeItem("mb-user-id")
    if (docName == "INE / IFE" || docName == "Pasaporte") {
      const nextComponent = 'IdentityValidationComponent'
      MicroblinkFunctions.doNextStage({ navigate, folioId, nextComponent })
    } else {
      const noCurentCapture = (location.state.noCurentCapture + 1)
      const nextComponent = 'CargarDocsComponent'
      MicroblinkFunctions.doNextStage({ navigate, folioId, nextComponent, qrProcess, ocrInfo, activeNSections, sectionsCapture, noCurentCapture })
    }
  }

  let getB64ByDocument = (docName, data) => {
    let b64Return = null
    switch (docName) {
      case "Anverso":
        b64Return = Uint8ArraytoB64(data.frente?.encodedImage)
        // console.log("Entro method:getB64ByDocument Anverso: ", b64Return)
        break
      case "Reverso":
        b64Return = Uint8ArraytoB64(data.reverso?.encodedImage)
        // console.log("Entro method:getB64ByDocument Reverso: ", b64Return)
        break
      case "Pasaporte":
        b64Return = Uint8ArraytoB64(data.imageBase64?.encodedImage)
        break
      case "Licencia de conducir":
        b64Return = Uint8ArraytoB64(data.imageBase64?.encodedImage)
        break
      case "Tarjeta de crédito":
        b64Return = Uint8ArraytoB64(data.imageBase64?.encodedImage)
        break
      default:
        break
    }
    return b64Return
  };

  return (<CustomMainContainer
    oneButton={true}
    body={<div>
       {activeGeolocation && 
                <GeoLocationGeneric SuccessFN={(latitude, longitude) => {
                    console.log("succes,latitude, longitude ", latitude, longitude);
                    setLatitude(latitude);
                    setLongitude(longitude);
                }}
                    ErrorFN={(error) => console.log('error', error)}
                />
            }
      {loadView || loadingSDK ? <CustomLoadingOverlay active={loadView || loadingSDK ? true : false} text={t("general_loading_message")} /> : null}
      <Typography
        variant="h6"
        gutterBottom
        className={localStyles.stageTitle}>
        <b>{docName}</b>
      </Typography>
      <IdScanMicroBlink docType={docName}
        onGetDocData={haddleDataCapture}
        setLoadingSDK={setLoadingSDK}
        setSDKSuccess={setSDKSuccess}
        visible={SDKSuccess}
      />

    </div>}
    buttons={<div className={localStyles.buttonWidths} >
      {!photoTaken && <Buttons
        className={localStyles.cancelBtn}
        size={100} text_color={theme.palette.primary.main}
        background_color='#ffffff'
        border_color={theme.palette.primary.main}
        text={t("general_cancel")}
        type='button' click={cancelPhoto} />
      }
    </div>}
  />
  );
}

